import parse from 'html-react-parser';
import { useEffect } from 'react';
import { setAlertsHtml, useAppState } from '../../hooks/app-state';
import { Container } from 'styled-bootstrap-grid';
import Skeleton from 'react-loading-skeleton';
import { getGlobalAlertsHtml, initAlerts } from '../../services/header.service';
import { getUser } from '../../app-context/accounts-context';

export function Alerts() {
    const [rawAlerts] = useAppState('rawAlerts');
    const user = getUser();

    useEffect(() => {
        if (!rawAlerts) {
            getGlobalAlertsHtml().then((html) => {
                setAlertsHtml(html);
            });
            return;
        }

        initAlerts();
    }, [rawAlerts]);

    if (!rawAlerts) {
        return (
            <>
                <Container>
                    <Skeleton height={90} />
                </Container>
                {user && <Container fluid={true}>
                    <Skeleton height={45} />
                </Container>}
            </>
        );
    }

    return (
        <>
            {parse(rawAlerts)}
        </>
    );
}
